import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import StoreApi from "../../services/Apis/Store.Api";
import SemiCircleProgress from "../../components/Chart";
import NpsGaugeWidget from "../../components/NpsGaugeWidget";
import { isFordStore, isKiaStore } from "../../utils/storeTypes";

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let navigate = useNavigate();
    let params = useParams();
    return <Component {...props} navigate={navigate} params={params} />;
  }

  return ComponentWithRouterProp;
}

class ChartView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      storesList: [],
      selectedStore: {},
    };
  }

  componentDidMount() {
    this.fetchStores();
  }

  fetchStores = async () => {
    try {
      const response = await StoreApi.getStores();
      const store_id = this.props.params.store_id;

      if (store_id) {
        const selectedStore = response.find(
          (store) => store.ID.toString() === store_id
        );
        if (selectedStore) {
          this.setState({ storesList: response, selectedStore });
        } else {
          this.props.navigate("/forbidden");
        }
      } else {
        this.props.navigate("/forbidden");
      }
    } catch (error) {
      console.error("Error fetching stores", error);
      this.props.navigate("/forbidden");
    }
  };

  render() {
    const store = this.state.selectedStore;
    const isKia = isKiaStore(store);
    const isFord = isFordStore(store);
    const periodLabel = moment(store.lastUpdate)
      .subtract(1, "month")
      .format("MMMM");

    return (
      <Box
        sx={{
          p: 0.5,
          m: 0,
          bgcolor: "#fafafa",
          minHeight: "auto",
          overflow: "hidden",
        }}
      >
        <Typography
          sx={{
            textAlign: "center",
            fontSize: 13,
            fontWeight: 700,
            m: 0,
            mb: 0.5,
            color: "#1a1a1a",
          }}
        >
          {periodLabel} {isFord ? "NPS" : isKia ? "Scores" : "CEI"}
        </Typography>

        {isFord ? (
          <NpsGaugeWidget store={store} periodLabel={periodLabel} />
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              gap: 0.5,
            }}
          >
            <SemiCircleProgress
              label={isKia ? "SSI" : "Sales"}
              size={75}
              maxValue={isKia ? 100 : 5}
              value={store.sales}
              delta={store.salesChange}
            />
            <SemiCircleProgress
              label={isKia ? "ASSI" : "Service"}
              size={75}
              maxValue={isKia ? 100 : 5}
              value={store.service}
              delta={store.serviceChange}
            />
            {isKia && (
              <SemiCircleProgress
                label="CSI"
                size={75}
                maxValue={100}
                value={store.csi}
                delta={""}
              />
            )}
          </Box>
        )}
      </Box>
    );
  }
}

export default withRouter(ChartView);
